<template>
  <div class="add-basic-information">
    <div class="add-title">
        <span class="basic title-font-style">客户信息</span>
    </div>
    <div class="add-content" style='padding-left:45px;padding-bottom:10px'>
      <el-form
        label-position="right"
        :model="queryParams"
        class="demo-form-inline"
        label-width="100px"
        :rules="addCustormerRules"
        ref="queryParamsRefs"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-col :span="21" style='padding:0px'>
              <el-form-item prop="cusName" label="客户名称：">
                <el-input v-model="queryParams.cusName" :disabled="customDisabled"  @keyup.native.enter="onSearch"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item label-width="0">
                <el-button type="primary" @click="onSearch(queryParams.cusName)" plain>查询</el-button>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="8">
            <el-form-item label="法人姓名：">
              <el-input :disabled="true" v-model="queryParams.cusElp"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="客户类型：">
              <el-select v-model="queryParams.cusType" placeholder="请选择">
                <el-option
                  v-for="(item,index) in customerType"
                  :key="index"
                  :label="item.attrName"
                  :value="item.attrName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属行业：">
              <el-select v-model="queryParams.cusIndustry" placeholder="请选择">
                <el-option
                  v-for="(item,index) in industryTypeList"
                  :key="index"
                  :label="item.attrName"
                  :value="item.attrName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="重要等级：">
              <el-select v-model="queryParams.cusImplevel" placeholder="请选择">
                <el-option
                  v-for="(item,index) in implevelType"
                  :key="index"
                  :label="item.attrName"
                  :value="item.attrName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="客户来源：">
              <el-select v-model="queryParams.cusFrom" placeholder="请选择" >
                <el-option
                  v-for="(item,index) in fromTypeList"
                  :key="index"
                  :label="item.attrName"
                  :value="item.attrName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款方式：">
              <el-select v-model="queryParams.cusPaytype" placeholder="请选择">
                <el-option
                  v-for="(item,index) in payTypeList"
                  :key="index"
                  :label="item.attrName"
                  :value="item.attrName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="padding-left:10px" v-show="queryParams.cusPaytype==='约定账期'">
            <el-form-item label="账期设置：" style="margin:0px;"  :rules="filter_rules({required:true})">
              <!-- 添加 -->
                <el-col :span="11">
                  <el-select v-model="queryParams.accountType" placeholder="请选择" :rules="filter_rules({required:true})">
                    <el-option
                      v-for="(item,index) in paymentDaySetList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="11">
                  <el-input v-model="queryParams.days" placeholder="请设置约定天数" :rules="filter_rules({required:true})"></el-input>
                </el-col>
                <el-col :span="2" style='padding-left:5px;'>
                  <el-form-item label-width="0px">天</el-form-item>
                </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="公司网站：">
              <el-input v-model="queryParams.cusSite"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="注册时间：">
              <el-input v-model="queryParams.suRegdate" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邮政编码：">
              <el-input maxlength='6' v-model="queryParams.cusZipcode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span='8'>
           <el-form-item label="工商地址：">
              <el-row>
                <el-col :span="8">
                  <el-select v-model="provinceManage.name" disabled>
                  </el-select>
                </el-col>
                <el-col :span="8" style="padding-left:10px">
                  <el-select v-model="cityManage.name" disabled>
                  </el-select>
                </el-col>
                <el-col :span="8" style="padding-left:10px;">
                  <el-select v-model="districtManage.name" disabled>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="详细地址：">
              <el-input v-model="queryParams.bizAddress" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
           <el-row :gutter="20">
          <el-col :span="8" style="padding-right:0px;">
            <el-form-item label="实际经营地址：">
              <el-address
                :provinceEdit="provinceReceiving"
                :city="cityReceiving"
                :district="districtReceiving"
                @changAddress="changAddress"
              ></el-address>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="详细地址：">
              <el-input v-model="queryParams.actualAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="企业备注：" placeholder="可填写备注信息">
              <el-input :rows="4" type="textarea" v-model="queryParams.mark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" >
          <el-col :span="8">
            <el-form-item label="当前负责人：" label-width="100px" >{{queryParams.principalName}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="委托人：" label-width="100px" >
              {{queryParams.clientName}}
              <el-button @click="updateConsignor">添加委托人</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--------------新增委托人 -------------->
    <consignor-dialog @consignorDialog="consignorDialog" ref="consignorDialogRefs"></consignor-dialog>
    <!--------------查询企业 -------------->
    <invoice-search-dialog @invoiceSearchDialog="invoiceSearchDialog" ref="invoiceSearchDialogRefs"></invoice-search-dialog>
    <!-- 验证码 -->
    <qrcode-dialog @qrcodeDialog="qrcodeDialog" ref="qrcodeDialogRefs"></qrcode-dialog>
  </div>
</template>

<script>
import address from '@/components/Address/indexName'
import consignorDialog from './dialog/consignorDialog'
import invoiceSearchDialog from './dialog/invoiceSearchDialog'
import qrcodeDialog from './dialog/qrcodeDialog'
import { queryEnterQueryEin, queryByCusName } from '@/api/customer/customerManage'
import { paymentDaySetList } from './utils/data'
import { getAuth } from '@/util/auth'

export default {
  props: [
    'isShow',
    'payTypeList',
    'industryTypeList',
    'fromTypeList',
    'customerType',
    'implevelType',
    'addressBase'
  ],
  components: {
    'consignor-dialog': consignorDialog,
    'el-address': address,
    'invoice-search-dialog': invoiceSearchDialog,
    'qrcode-dialog': qrcodeDialog
  },
  mounted() {
    this.getUser()
  },
  data () {
    return {
      id: 0,
      cityReceiving: {},
      districtReceiving: {},
      provinceReceiving: {},
      provinceManage: {}, // 经营省
      cityManage: {}, // 经营市
      districtManage: {}, // 经营区/县
      customDisabled: false,
      queryParams: {
        bizProvince: '',
        bizProcode: '',
        clientName: undefined
      },
      name: '',
      addCustormerRules: {
        cusName: [
          { required: true, trigger: 'blur', message: '客户名称不能为空' }
        ]
      },
      paymentDaySetList: paymentDaySetList // 账期设置
    }
  },

  methods: {
    // 登录人
    getUser () {
      this.queryParams.principalName = JSON.parse(getAuth()).usercnname
    },
    // 经营地址
    async changAddress (params) {
      this.queryParams.actualProvince = params.name
      this.queryParams.actualProcodeCode = params.code
    },
    qrcodeDialog (formLabelAlign, data) {
      this.$refs.invoiceSearchDialogRefs.onInitial(data, formLabelAlign)
    },
    // 查新客户返回emit
    invoiceSearchDialog (val) {
      this.customDisabled = true
      this.queryParams.cusName = val.entname
      this.queryParams.cusElp = val.legalname
      if (val.esdate !== '') {
        this.queryParams.suRegdate = val.esdate
      } else {
        this.queryParams.suRegdate = ''
      }
      this.id = val.id
      queryEnterQueryEin(val.id)
        .then((res) => {
          if (res.data.code === 200) {
            this.queryParams.entname = res.data.obj.entname
            this.queryParams.gongsh = res.data.obj.gongsh
            this.queryParams.orgcode = res.data.obj.orgcode
            this.queryParams.taxnumber = res.data.obj.taxnumber
            this.queryParams.uncid = res.data.obj.uncid
            this.queryParams.suRegdat = res.data.obj.esdate
            this.queryParams.bizProvince = res.data.obj.bizProvince
            if (res.data.obj.village) {
              this.$set(this.queryParams, 'bizAddress', res.data.obj.village)
            } else {
              this.$set(this.queryParams, 'bizAddress', res.data.obj.oploc)
            }
            this.$emit(
              'onCompanyName',
              res.data.obj
            )
            if (this.queryParams.bizProvince !== null) {
              const ManageParams = this.$analysisAddressName(
                this.queryParams.bizProvince
              )
              const arr = [] // 这是有用的
              arr.push(ManageParams.province.id)
              arr.push(ManageParams.city.id)
              arr.push(ManageParams.district.id)
              this.queryParams.bizProcode = arr.join('-')
              this.provinceManage = ManageParams.province // 经营省
              this.cityManage = ManageParams.city // 经营市
              this.districtManage = ManageParams.district// 经营区/县
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 查询
    onSearch (cusName) {
      this.$refs.queryParamsRefs.validate((valid) => {
        if (valid) {
          // 验证客户名称是否重复
          queryByCusName(this.queryParams.cusName)
            .then((res) => {
              if (res.data.code === 200) {
                this.$refs.qrcodeDialogRefs.onInitial(cusName)
                this.$message.success('客户名称验证通过')
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else {
          this.$message.error('请输入客户名称')
        }
      })
    },
    consignorDialog (val) {
      this.queryParams.clientId = val.clientId
      this.queryParams.clientName = val.clientName
      this.queryParams.clientOrg = val.clientOrg
    },
    // 添加委托人
    updateConsignor () {
      this.$refs.consignorDialogRefs.onInitial('add')
    },
    // 客户信息校验
    onCustormerRules () {
      this.$refs.queryParamsRefs.validate((valid) => {
        // 传递bool值给父级告诉父级校验是否通过
        if (valid) {
          if (this.queryParams.cusPaytype === '约定账期') {
            if (!this.queryParams.accountType || !this.queryParams.days) {
              this.$message.error('账期设置不能为空')
            } else {
              this.$emit('onParent')
            }
          } else {
            this.$emit('onParent')
          }
        } else {
          this.$message.error('必填项不能为空')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.star {
  padding: 0px 17px 0px 14px;
}
.bold {
  height:20px;
   width:4px;
}
</style>
